// extracted by mini-css-extract-plugin
export default {"container":"Ej-z","blurb":"Fj-z","links":"Gj-z"};